import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const CheckFilledIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.36396 15.1924L18.5564 6L19.9706 7.41421L9.36396 18.0208L3 11.6569L4.41422 10.2427L9.36396 15.1924Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { CheckFilledIcon };
